module.exports = __webpack_public_path__ + "static/media/help_chat.c88d8bb6.svg";